import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Table, Popup, Button, Icon } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";

const ListSettlementReport = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    loadDataSettlement,
    getDocumentsSettlement,
    documentsSettlement,
    detailSettlement,
    countSettlement,
  } = rootStore.reportStore;
  useEffect(() => {
    getDocumentsSettlement();
  }, [getDocumentsSettlement]);

  if (!loadDataSettlement) return <LoadingComponent content="Cargando" />;
  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Agente Comercial</Table.HeaderCell>
          <Table.HeaderCell>NIT</Table.HeaderCell>
          <Table.HeaderCell>No. Documentos</Table.HeaderCell>
          <Table.HeaderCell>Vr. Documento</Table.HeaderCell>
          <Table.HeaderCell>Valor a pagar</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {documentsSettlement?.length > 0 ? (
          documentsSettlement.map((b) => (
            <Table.Row key={`${b.brokerId}-${b.companyId}`}>
              <Table.Cell singleLine>{b.brokerName}</Table.Cell>
              <Table.Cell singleLine>{b.companyId}</Table.Cell>
              <Table.Cell>{b.numberOfDocuments}</Table.Cell>
              <Table.Cell>{b.unitPrice.toFixed(2)}</Table.Cell>
              <Table.Cell>{b.totalPrice.toFixed(2)}</Table.Cell>
              <Table.Cell>
                <div>
                  <Popup
                    content="Ver detalle"
                    trigger={
                      <Button
                        icon
                        onClick={() => {
                          detailSettlement(b.brokerName, b.brokerId);
                        }}
                      >
                        <Icon name="search plus" color="black" />
                      </Button>
                    }
                  />
                </div>
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="settlementReportNull">
            <Table.Cell>No existen Agentes</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell>Total a facturar</Table.HeaderCell>
          <Table.HeaderCell>${countSettlement.toFixed(2)}</Table.HeaderCell>
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
    </Table>
    </div>
  );
};

export default observer(ListSettlementReport);
